const THEME_GRAPHITE_ORANGE = {
    id: "graphite-orange",
    className: "theme-graphite-orange",
    hosts: [
        "qr.powerboxcharging.co.uk",
    ],
};

const THEME_MAGZAPPY = {
    id: "magzappy",
    className: "theme-magzappy",
    hosts: [
        "qr.magzappy.com",
    ],
};

const THEME_ESCARGOT = {
    id: "escargot",
    className: "theme-escargot",
    hosts: [
        "myescargot.com",
        "www.myescargot.com",
        "qr.myescargot.com",
        "192.168.0.128"
    ],
};

const THEMES = [THEME_GRAPHITE_ORANGE, THEME_MAGZAPPY, THEME_ESCARGOT];

function matchesHost(theme, hostname) {
    return theme.hosts.includes(hostname);
}

export function getActiveTheme(hostname = window.location.hostname) {
    return THEMES.find((theme) => matchesHost(theme, hostname)) || null;
}

export function applyHostTheme() {
    const root = document.documentElement;
    const body = document.body;

    THEMES.forEach((theme) => {
        root.classList.remove(theme.className);
        if (body) {
            body.classList.remove(theme.className);
        }
    });

    const activeTheme = getActiveTheme();
    if (!activeTheme) return null;

    root.classList.add(activeTheme.className);
    if (body) {
        body.classList.add(activeTheme.className);
    }

    return activeTheme;
}
